import { all } from 'redux-saga/effects';
import aptServiceSagas from 'store/appt/sagas';
import customerServiceSagas from 'store/customer/sagas';
import galleryServiceSagas from 'store/gallery/sagas';
import notificationServiceSagas from 'store/notification/sagas';
import shopServiceSagas, { initShopData } from 'store/shop/sagas';
// no SagaIterator annotation: yields all() over plain iterators (not effects)
export default function* rootSaga() {
  yield all([
    shopServiceSagas(),
    aptServiceSagas(),
    customerServiceSagas(),
    galleryServiceSagas(),
    notificationServiceSagas(),
  ]);
}
